import { Component, Input, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalWarningComponent } from '../modal-warning/modal-warning.component';
import { HeaderData, IHeaderData } from './header-data.models';

@Component({
  selector: 'app-header-data',
  templateUrl: './header-data.component.html',
  styleUrls: ['./header-data.component.scss']
})
export class HeaderDataComponent {
  @Input() confirmation?: boolean = null;
  @Input() confirmationAction?: string = null;
  @Input() changes = false;
  @Input() set headerCol(value: IHeaderData) {
    if (value.type === 'items') {
      const trunc: HeaderData[] = value.data.filter(
        (res: HeaderData) => res.truncate && typeof (res.field[0]) === 'string' && res.field[0].length > 20
      );
      if (trunc.length > 0) {
        trunc.forEach((value2: HeaderData) => {
          value2.field[0] = (value2.field[0] as string).slice(0, 17) + '...';
        });
      }
    }
    this.columnHeader = value;
  };
  @Output() clickButton: EventEmitter<string> = new EventEmitter();
  public saved = false;
  public columnHeader: IHeaderData;

  constructor(public dialogRef: MatDialog) { }

  public handleButton(name: string, source?: string): void {
    this.saved = this.confirmationAction === name;
    if (!this.saved) {
      if (this.confirmation && this.changes) {
        this.openDialog();
      } else {
        if (!this.changes) {
          this.clickButton.emit(name);
        }
      }
    } else {
      this.clickButton.emit(name);
    }
  }

  public openDialog(): void {
    const dialogRef = this.dialogRef.open(ModalWarningComponent, {
      width: '575px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => { });

    dialogRef.componentInstance.onSave.subscribe(result => {
      if (result) {
        this.clickButton.emit(this.confirmationAction);
      } else {
        this.clickButton.emit();
      }
    });
  }
}
